import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type {
  NotificationState,
  TNotification,
  TNotificationObject,
} from "./types";
import { generateId } from "../../../shared/utils/generateId";

const initialState: NotificationState = {
  notifications: [],
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    createNotification: {
      reducer(
        state: NotificationState,
        action: PayloadAction<TNotificationObject>,
      ) {
        if (state.notifications.some((note) => note.id === action.payload.id))
          return;
        state.notifications = [...state.notifications, action.payload];
      },
      prepare(
        type: TNotification,
        message: string,
        hideDuration?: number,
        title?: string,
        isIgnoreNotify?: boolean,
      ) {
        return {
          payload: {
            id: generateId(),
            type,
            message,
            hideDuration: hideDuration ? hideDuration : 5000,
            title: title ? title : "",
            isIgnoreNotify: isIgnoreNotify ? isIgnoreNotify : false,
          },
        };
      },
    },
    hideNotification: (state, action: PayloadAction<string>) => {
      state.notifications = state.notifications.filter(
        (note) => note.id !== action.payload,
      );
    },
  },
});

export const notificationReducers = notificationSlice.reducer;
export const { createNotification, hideNotification } =
  notificationSlice.actions;
